import { LeftOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GradientButton from "../Button/GradientButton";
import {
  Button,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Steps,
} from "antd";
import ModalView from "../CustomModal/ModalView";

function ProjectDataDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState();
  const { state } = location;
  const data = state?.data;
  const [form] = Form.useForm();
  const choice = Form.useWatch("choice", form);
  return (
    <ConfigProvider
      theme={{
        token: {
          /* here is your global tokens */
          colorPrimary: "#FF6B38",
        },
      }}
    >
      <div className="bg-pureWhite rounded-2xl p-4 courses_Style">
        <div
          className="w-fit flex items-center gap-x-2 cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <LeftOutlined style={{ color: "#8F8F8F", fontSize: 18 }} />
          <p className="text-[#8F8F8F] text-sm">Back to projects</p>
        </div>
        <div className="mt-7 flex flex-col lg:flex-row items-center justify-between">
          <div className="flex gap-4 items-center w-[70%]">
            <div className="rounded-2xl">
              <img
                // src={`${data?.ImageUrl}`}
                src="https://cdn.prod.website-files.com/63c5e29f1b5bc83fe0af2489/6424d753f8eb7a9e69c372fc_Gantt%20Chart%20Online%20Software%20Instagantt%20Ideation%202.webp"
                alt="Course Main Image"
                className=" h-32 border-2 rounded-2xl"
                width={200}
                height={200}
              />
            </div>
            <div>
              <p className="text-2xl lg:text-3xl font-semibold font-bizmo">
                {data?.Title}
              </p>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center lg:items-center lg:justify-center">
            <GradientButton onClick={() => setModalOpen(true)}>
              Submit Proposal
            </GradientButton>
            {/* <GradientButton>
              <Link target="_" to={data?.Link}>
                Visit Project
              </Link>
            </GradientButton> */}
            <p className="text-xs lg:text-sm text-[#8F8F8F] mt-2">
              Budget:
              {data?.Budget}
            </p>
          </div>
        </div>
        <div className="mt-12 mx-4">
          <Steps
            size="small"
            current={3}
            progressDot
            status="finish"
            items={[
              {
                // title: "In Process",
              },
              {
                // title: "Evaluation",
              },
              {
                // title: "Submission",
              },
            ]}
          />
        </div>
        <div className="flex">
          <div className="p-5">
            <p className="text-lg font-bold">Extra Resources</p>
            {data?.ExtraResources?.map((sme, id) => {
              return <h1 key={id}>{sme}</h1>;
            })}
          </div>
          <div className="p-5">
            <p className="text-lg font-bold">Assigned Users</p>
            {data?.AssignedUsers?.map((sme, id) => {
              return <h1 key={id}>{sme}</h1>;
            })}
          </div>
          <div className="p-5">
            <p className="text-lg font-bold">List Of Sme Managing Project</p>
            {data?.ListOfSmeManagingProject?.map((sme, id) => {
              return <h1 key={id}>{sme}</h1>;
            })}
          </div>
          <div className="p-5">
            <p className="text-lg font-bold">Optional Skills</p>
            {data?.OptionalSkills?.map((sme, id) => {
              return <h1 key={id}>{sme}</h1>;
            })}
          </div>
          <div className="p-5">
            <p className="text-lg font-bold">Required Skills</p>
            {data?.RequiredSkills?.map((sme, id) => {
              return <h1 key={id}>{sme}</h1>;
            })}
          </div>
        </div>
        <div>
          <div className="p-5">
            <p className="text-lg font-bold">Risk</p>
            {data?.Risks?.map((risk, id) => {
              return (
                <div key={id} className="flex gap-3">
                  <h1>{risk.RiskImpact}:</h1>
                  <p>{risk.RiskDescription}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="p-5">
          <p className="text-lg font-bold">Description</p>
          <p>{data?.LongDescription}</p>
        </div>
      </div>
      <ModalView
        visible={modalOpen}
        onClose={() => setModalOpen(false)}
        centered
        // width={width}
        footer={false}
      >
        <Form
          layout="vertical"
          variant="filled"
          form={form}
          onFinish={() => setModalOpen(false)}
        >
          <Form.Item
            label="Proposal"
            name="proposal"
            rules={[
              {
                required: true,
                message: "Please input! Proposal",
              },
            ]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="Proposal Amount"
            name="proposalAmount"
            rules={[
              {
                required: true,
                message: "Please input Proposal Amount!",
              },
            ]}
          >
            <InputNumber
              style={{
                width: "100%",
              }}
            />
          </Form.Item>
          <Form.Item
            label="How long will this project take?"
            name="howLong"
            rules={[
              {
                required: true,
                message: "Please Select Field!",
              },
            ]}
          >
            <Select placeholder="Select a duration">
              <Select.Option key="More than 6 months">
                More than 6 months
              </Select.Option>
              <Select.Option key="3 to 6 months">3 to 6 months</Select.Option>
              <Select.Option key="1 to 3 months">1 to 3 months</Select.Option>
              <Select.Option key="Less than 1 month">
                Less than 1 month
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Do you want to work with other talent in this project?"
            name="choice"
            rules={[
              {
                required: true,
                message: "Please select yes or no!",
              },
            ]}
          >
            <Radio.Group>
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
          {choice === "Yes" && (
            <Form.Item
              label="please select the Talent"
              name="talent"
              rules={[
                {
                  required: true,
                  message: "Please Select Talent!",
                },
              ]}
            >
              <Select placeholder="Select a Talent" mode="multiple">
                <Select.Option key="Ali">Ali</Select.Option>
                <Select.Option key="Husnain">Husnain</Select.Option>
                <Select.Option key="Alqama">Alqama</Select.Option>
                <Select.Option key="Rafay">Rafay</Select.Option>
              </Select>
            </Form.Item>
          )}
          <Form.Item>
            <GradientButton className="w-full" htmlType="submit">
              Submit
            </GradientButton>
          </Form.Item>
        </Form>
      </ModalView>
    </ConfigProvider>
  );
}

export default ProjectDataDetails;
